import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconGitHub = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#Icon_GitHub_svg__a)"><path fill="currentColor" d="M32 .747a32 32 0 0 0-9.92 62.426h.747a2.67 2.67 0 0 0 1.866-.64 2.8 2.8 0 0 0 .96-2.186V56.88a1.3 1.3 0 0 0-.506-.88 1.33 1.33 0 0 0-1.094-.267C16.88 57.28 15.36 52.8 15.28 52.507a12.37 12.37 0 0 0-4.613-5.84l-.4-.294a1.95 1.95 0 0 1 1.013-.186 3.95 3.95 0 0 1 3.04 2.346 8 8 0 0 0 10.667 3.094 1.41 1.41 0 0 0 .8-.96 5.33 5.33 0 0 1 1.493-3.254 1.33 1.33 0 0 0 .4-1.413 1.31 1.31 0 0 0-1.12-.933c-6.32-.72-12.8-2.934-12.8-13.84a10.67 10.67 0 0 1 2.827-7.414 1.31 1.31 0 0 0 .24-1.386A9.5 9.5 0 0 1 16.853 16a14.85 14.85 0 0 1 6.72 3.067 1.28 1.28 0 0 0 1.12.16 28.4 28.4 0 0 1 7.307-.96 27.5 27.5 0 0 1 7.333.96 1.23 1.23 0 0 0 1.094-.16A14.75 14.75 0 0 1 47.147 16a9.44 9.44 0 0 1 0 6.347 1.28 1.28 0 0 0 .266 1.386c1.832 2 2.833 4.622 2.8 7.334 0 10.933-6.48 13.12-12.826 13.813a1.31 1.31 0 0 0-1.12.933 1.31 1.31 0 0 0 .4 1.387 5.95 5.95 0 0 1 1.626 4.667v8.48a2.83 2.83 0 0 0 .987 2.186 3.15 3.15 0 0 0 2.827.507A32 32 0 0 0 32 .747" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_GitHub_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconGitHub.displayName = 'IconGitHub';